import Api from '../api';
import { CompanyCustomField } from './ai_management_proposal_company';

export interface ProposalConditionValues {
  validade_dias: number | null;
  prazo_entrega_dias: number | null;
  condicoes_pagamento: string | null;
  garantia: string | null;
}

// A validade é mínimo; o prazo de entrega é o limite MÁXIMO do edital, apesar do nome da chave.
export interface ProposalConditionsResponse {
  valores: ProposalConditionValues;
  campos_personalizados: CompanyCustomField[];
  minimos: {
    validade_dias: number | null;
    prazo_entrega_dias: number | null;
  };
}

// O PUT substitui todas as condições: o payload vai sempre completo.
export interface ProposalConditionsPayload {
  validade_dias: string;
  prazo_entrega_dias: string;
  condicoes_pagamento: string;
  garantia: string;
  campos_personalizados: CompanyCustomField[];
}

const basePath = (biddingId: number) => `/gestao_ia/licitacoes/${biddingId}/proposta/condicoes`;

export const getProposalConditions = (biddingId: number) =>
  Api.get<ProposalConditionsResponse>(basePath(biddingId));

export const updateProposalConditions = (biddingId: number, payload: ProposalConditionsPayload) =>
  Api.put<ProposalConditionsResponse>(basePath(biddingId), payload);
